import { Stage } from "./Stage";

export class RouteStages {
  fromStage = new Stage();
  toStage = new Stage();
  viaStage = new Stage();
}